import React from 'react';

//  Styles
import './Spinner.scss';

const Spinner = ({ color }) => {
    return (
        <div className={`spinner-${color}`}></div>

    )
}

export default Spinner;
